import script from "./BlockKerja.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockKerja.vue?vue&type=script&setup=true&lang=js"

import "./BlockKerja.vue?vue&type=style&index=0&id=6a86d7d1&lang=css"

const __exports__ = script;

export default __exports__